import React from 'react';
import PropTypes from 'prop-types';

import { MAP_LAYER_ROAD_RESTRICTIONS } from '../../../constants';
import MapSettingsItem from '../MapSettingsItem';

import Icon from '../../../../assets/icon_map_settings_road_restrictions_active.svg';
import IconInactive from '../../../../assets/icon_map_settings_road_restrictions_inactive.svg';

const MapLayerRoadRestrictionsItem = props => {
    const { activeBuiltinLayers, onMapLayerChange, onToggle, ...remainingProps } = props;

    const handleToggle = () => {
        onMapLayerChange(MAP_LAYER_ROAD_RESTRICTIONS);
        onToggle();
    };

    return (
        <MapSettingsItem
            className={'MapLayerRoadRestrictions'}
            onClick={handleToggle}
            isActive={activeBuiltinLayers.includes(MAP_LAYER_ROAD_RESTRICTIONS)}
            activeIcon={<Icon />}
            inactiveIcon={<IconInactive />}
            {...remainingProps}
        />
    );
};

MapLayerRoadRestrictionsItem.displayName = 'MapLayerRoadRestrictionsItem';

MapLayerRoadRestrictionsItem.defaultProps = {
    activeBuiltinLayers: [],
    onMapLayerChange: () => {},
    onToggle: () => {},
};

MapLayerRoadRestrictionsItem.propTypes = {
    activeBuiltinLayers: PropTypes.array,
    onMapLayerChange: PropTypes.func,
    onToggle: PropTypes.func,
};

export default MapLayerRoadRestrictionsItem;
